// extracted by mini-css-extract-plugin
export default {"container_dark":"T0JonepW","container_light":"TImi_jHG"};